import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=0fdf14b2&scoped=true&"
import script from "./SearchProducts.vue?vue&type=script&lang=js&"
export * from "./SearchProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=0fdf14b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf14b2",
  null
  
)

export default component.exports